export default {"src":"/_next/static/media/chevron-right.2bb59c31.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};